export default defineNuxtPlugin((nuxtApp) => {
  // only run in the browser
  if (process.client) {
    window.addEventListener('cookieyes:consent', (e) => {
      // e.detail.categories.analytics will be true once the user opts in
      if (e.detail.categories.analytics) {
        const { initialize } = useGtag();
        initialize();const { gtag } = useGtag()  // loads & configures gtag.js

        // update Google Consent Mode v2
        gtag('consent', 'update', {
          ad_storage: 'granted',
          analytics_storage: 'granted',
        })
      }
    })
  }
})